import { Button, FormHelperText, Grid } from '@mui/material';
import { ProductFields } from 'new/product-fields';
import { useCallback, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { defaultProduct } from 'shared/constants';
import { ICustomProduct } from 'shared/types';

export function ProductInfo() {
  const {
    watch,
    setError,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: 'products',
  });
  const watchProducts = watch('products');
  const watchCustomProducts = watch('customProducts') as ICustomProduct[];

  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchProducts[index],
  }));

  useEffect(() => {
    if (isSubmitting && !fields.length && !watchCustomProducts?.length) {
      setError('products', {
        message: 'At least one product is required',
        type: 'custom',
      });
    }
  }, [fields, watchCustomProducts, isSubmitting, setError]);

  const addProduct = useCallback(() => {
    clearErrors('products');
    clearErrors('customProducts');
    append(defaultProduct());
  }, [clearErrors, append]);

  const removeProduct = (index: number) => () => {
    remove(index);
  };

  return (
    <Grid container spacing={2} direction='column'>
      <Grid item>
        <Button onClick={addProduct} variant='contained'>
          Add Product
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          {controlledFields.map((field, index) => (
            <ProductFields
              key={field.id}
              product={field}
              index={index}
              remove={removeProduct}
              isLastProduct={index === controlledFields.length - 1}
              addProduct={addProduct}
            />
          ))}
        </Grid>
        <Grid xs={12} item>
          <FormHelperText error>{errors?.products?.message}</FormHelperText>
        </Grid>
      </Grid>
    </Grid>
  );
}
